import React, { useState, useEffect } from 'react';

const EditBrandModal = ({ 
    isOpen, 
    brand, 
    onClose, 
    onSave 
}) => {
    const [formData, setFormData] = useState({
        name_ko: '',
        name_en: '',
        source_site: ''
    });

    useEffect(() => {
        if (brand) {
            setFormData({
                name_ko: brand.name_ko || '',
                name_en: brand.name_en || '',
                source_site: brand.source_site || ''
            });
        }
    }, [brand]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        await onSave(formData);
    };

    const handleClose = () => {
        setFormData({
            name_ko: '',
            name_en: '',
            source_site: ''
        });
        onClose();
    };

    if (!isOpen || !brand) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={handleClose}>
            <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4 relative" onClick={(e) => e.stopPropagation()}>
                {/* 닫기 버튼 */}
                <button 
                    onClick={handleClose}
                    className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-2xl"
                >
                    ×
                </button>
                
                <h3 className="text-xl font-semibold text-gray-800 mb-6 text-center">
                    브랜드 수정
                </h3>
                
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            브랜드명 (한글)
                        </label>
                        <input
                            type="text"
                            name="name_ko"
                            value={formData.name_ko}
                            onChange={handleChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            required
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            브랜드명 (영문)
                        </label>
                        <input
                            type="text"
                            name="name_en"
                            value={formData.name_en}
                            onChange={handleChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            required
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            출처 사이트
                        </label>
                        <input
                            type="text"
                            name="source_site"
                            value={formData.source_site}
                            onChange={handleChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="예: oliveyoung, musinsa, weverse 등"
                        />
                    </div>

                    <div className="flex justify-end gap-3 mt-6">
                        <button
                            type="button"
                            onClick={handleClose}
                            className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
                        >
                            취소
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-slate-600 text-white rounded-lg hover:bg-slate-700 transition-colors"
                        >
                            저장
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditBrandModal;

